// apiConfig.js
// process.env.REACT_APP_BACKEND_URL ||
// const backendUrl = process.env.REACT_APP_BACKEND_URL;
const backendUrl = "http://13.127.221.120:3000";

export default backendUrl;
